export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const splitHighLow = (value: number): [number, number] => {
  /**
   * High byte
   * Low byte
   */
  const high = Math.floor(value / 256);
  const low = value % 256;
  return [high, low];
};

export const mergeHighLow = (high: number, low: number): number => {
  return high * 256 + low;
};
